module.exports = {
  'en': {
    'HRES6BUC1': {
      '0': '[HRES6BU] List of Change Actual Time',
      '10': '[HRES6BU] List of Change Actual Time',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req. Date',
      '60': 'Work Date',
      '70': 'Shift 1',
      '80': 'Actual Time In - Out',
      '90': 'Old',
      '99': 'Select All',
      '100': 'New',
      '110': 'Reason of Change',
      '120': 'Status',
      '130': 'Approve by',
      '140': 'Appr. Date',
      '150': 'Remark',
      '160': 'Next Approve',
      '170': 'Num Seq'
    },
    'HRES6BUC2': {
      '0': 'Approve Detail',
      '10': 'For Emp. ID.',
      '20': 'Seq. Approve',
      '30': 'Approved By',
      '40': 'Date',
      '50': 'Current Status',
      '60': 'Status',
      '70': 'Approved',
      '80': 'Refused',
      '90': 'Remark',
      '100': 'No.of selected',
      '110': 'Record'
    },
    'HRES6BUC3': {
      '0': 'Details of Time Change',
      '10': 'Details of Time Change',
      '20': 'Employee ID.',
      '30': 'Request Date',
      '40': 'Working Date',
      '50': 'Shift 1',
      '60': 'Schedule Time',
      '70': 'Actual Time -Old',
      '80': 'Actual Time- New',
      '90': 'Shift 2',
      '100': 'Schedule Time',
      '110': 'Actual Time Old',
      '120': 'Actual Time-new',
      '130': 'Reason of Change',
      '140': 'Detail of Actual Time',
      '150': 'Detail of Schedule',
      '160': 'Detail',
      '170': 'Update By'
    },
    'HRES6BUC4': {
      '0': 'Actual Time in-out',
      '10': 'Actual Time in-out',
      '20': 'Employee Name',
      '30': 'Date',
      '40': 'Day',
      '50': 'Shift',
      '60': 'Schedule Time',
      '70': 'Time In',
      '80': 'Time Out'
    }
  },
  'th': {
    'HRES6BUC1': {
      '0': '[HRES6BU] อนุมัติการแก้ไขเวลาเข้า - ออก',
      '10': '[HRES6BU] อนุมัติการแก้ไขเวลาเข้า - ออก',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ขอ',
      '60': 'วันที่ทำงาน',
      '70': 'รหัสกะ1',
      '80': 'เวลาเข้า-ออกงานจริง',
      '90': 'เก่า',
      '99': 'เลือกทั้งหมด',
      '100': 'ใหม่',
      '110': 'สาเหตุการขอเปลี่ยน',
      '120': 'สถานะ',
      '130': 'ผู้อนุมัติ',
      '140': 'วันที่อนุมัติ',
      '150': 'หมายเหตุการอนุมัติ',
      '160': 'ผู้อนุมัติลำดับถัดไป',
      '170': 'ลำดับที่'
    },
    'HRES6BUC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่',
      '50': 'สถานะปัจจุบัน',
      '60': 'สถานะ',
      '70': 'อนุมัติ',
      '80': 'ไม่อนุมัติ',
      '90': 'หมายเหตุ',
      '100': 'รายการที่เลือกทั้งหมด',
      '110': 'รายการ'
    },
    'HRES6BUC3': {
      '0': 'รายละเอียดการขอแก้ไขเวลาเข้า-ออก',
      '10': 'รายละเอียดการขอแก้ไขเวลาเข้า-ออก',
      '20': 'รหัสพนักงาน',
      '30': 'วันที่ยื่นคำร้อง',
      '40': 'วันที่ทำงาน',
      '50': 'รหัสกะ1',
      '60': 'เวลาการปฎิบัติงาน',
      '70': 'เวลาเข้า-ออกเดิม',
      '80': 'เวลาเข้า-ออกจริง',
      '90': 'รหัสกะ2',
      '100': 'เวลาการปฎิบัติงาน',
      '110': 'เวลาเข้า-ออกเดิม',
      '120': 'เวลาเข้า-ออกจริง',
      '130': 'สาเหตุการขอเปลี่ยน',
      '140': 'ตารางเวลาเข้าออกจริง',
      '150': 'ตารางการทำงาน',
      '160': 'รายละเอียด',
      '170': 'ผู้บันทึก'
    },
    'HRES6BUC4': {
      '0': 'รายละเอียดเวลาปฏิบัติงาน',
      '10': 'รายละเอียดเวลาปฏิบัติงาน',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่',
      '40': 'วัน',
      '50': 'รหัสกะ',
      '60': 'เวลาปฏิบัติงาน',
      '70': 'เวลารูดบัตรเข้า',
      '80': 'เวลารูดบัตรออก'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6bu.js